(function() {
  // Build variant ID → hamper handle map on page load
  const variantHamperMap = {};

  async function buildVariantMap() {
    try {
      for (const hamperHandle of Object.keys(window.HAMPER_LINES_MAP || {})) {
        const productJson = await fetch(`/products/${hamperHandle}.json`).then(r => r.json()).catch(() => null);
        if (productJson?.product?.variants) {
          productJson.product.variants.forEach(v => {
            variantHamperMap[v.id] = hamperHandle;
          });
        }
      }
    } catch (e) {
      console.debug('[hamper-interceptor] Map building error:', e);
    }
  }

  // Build map immediately
  buildVariantMap();

  const originalFetch = window.fetch;

  window.fetch = async function(...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0].url;
    const init = typeof args[0] === 'string' ? args[1] : args[0];

    // Intercept cart add requests
    if (url && url.includes('/cart/add')) {
      try {
        let bodyData = init && init.body ? init.body : null;
        let isJson = false;

        if (bodyData) {
          let parsed;
          if (typeof bodyData === 'string') {
            isJson = true;
            parsed = JSON.parse(bodyData);
          } else if (bodyData instanceof FormData) {
            parsed = Object.fromEntries(bodyData);
          } else {
            parsed = bodyData;
          }

          const variantId = parseInt(parsed.id || parsed.items?.[0]?.id);

          // Fast lookup using pre-built map
          if (variantId && window.HAMPER_LINES_MAP && variantHamperMap[variantId]) {
            const hamperHandle = variantHamperMap[variantId];
            const hamperLines = window.HAMPER_LINES_MAP[hamperHandle];

            if (hamperLines) {
              const properties = {};

              // Add all items in a single property, comma-separated
              const itemsList = hamperLines
                .map(item => item.title ? `1x ${item.title}` : '1x Product')
                .join(', ');
              properties['Hamper Contents'] = itemsList;

              // Store hidden JSON for backend
              properties['_hamper_json'] = JSON.stringify(hamperLines);

              // Store hidden detailed items for Xero
              let itemCount = 1;
              hamperLines.forEach(item => {
                const itemKey = `_item_${String(itemCount).padStart(2, '0')}`;
                const itemValue = item.title
                  ? `1x ${item.title} [SKU: ${item.sku}] - €${(item.price / 100).toFixed(2)}`
                  : `1x [SKU: ${item.sku}] - €${(item.price / 100).toFixed(2)}`;
                properties[itemKey] = itemValue;
                itemCount++;
              });

              // Add properties to FormData request only
              if (bodyData instanceof FormData) {
                Object.entries(properties).forEach(([key, value]) => {
                  bodyData.append(`properties[${key}]`, value);
                });
              }

              console.log('[hamper-interceptor] Added properties for:', hamperHandle, properties);
            }
          }
        }
      } catch (e) {
        console.debug('[hamper-interceptor] Error:', e);
      }
    }

    return originalFetch.apply(this, args);
  };
})();
